import { schemeGetTopoExpandStatusApi, schemeSetTopoExpandStatusApi } from '@/api';
const state = {
  topoImg: {},
  topoExpand: 0, //拓扑节点是否展开 0：不展开， 1：展开
  unBindTopoDevice: [] //未加入拓扑的设备
};

const mutations = {
  SET_TOPO_IMG_SIZE(state, payload) {
    state.topoImg = { ...state.topoImg, ...payload };
  },
  SET_TOPO_STATUS(state, payload) {
    state.topoExpand = payload;
  },
  SET_UN_BIND_TOPO_DEVICE(state, payload) {
    state.unBindTopoDevice = payload;
  },
  RESET_UB_BIND_DEVICE(state) {
    state.unBindTopoDevice = [];
  }
};

const actions = {
  //获取拓扑状态（展开所有节点或者是收起）
  async getTopoStatus({ commit }, params) {
    const { schemeId } = params;
    const { code, msg, data = {} } = await schemeGetTopoExpandStatusApi(schemeId);
    if (code != 0) {
      return { success: false, msg };
    }
    commit('SET_TOPO_STATUS', data.topoExpand);
    return { success: true };
  },

  //设置拓扑状态
  async setTopoStatus({ commit }, params) {
    const { schemeId, expand } = params;
    const { code, msg } = await schemeSetTopoExpandStatusApi(
      {
        query: {
          expand
        }
      },
      schemeId
    );
    if (code != 0) {
      return { success: false, msg };
    }
    commit('SET_TOPO_STATUS', expand);
    return { success: true };
  }
};

const getters = {};

export default {
  namespaced: true, //开启命名空间，更好的区分使用stage,防止不同stage模块中的方法重名
  state,
  getters,
  mutations,
  actions
};
